<template>
  <el-select
    v-model="currentVal"
    v-bind="$attrs"
    v-on="$listeners"
    v-loadMore="loadMoreFunc"
    :infinite-scroll-disabled="noMore"
    style="color: #010517"
  >
    <slot>
      <el-option
        v-for="item in list"
        :key="item.value"
        :value="item.value"
        :label="item.label"
        :disabled="itemDisabled(item)"
        :class="item.class"
      />
    </slot>
  </el-select>
</template>
<script>
export default {
  name: 'ZSelect',
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    // eslint-disable-next-line vue/require-prop-types
    value: {},
    formatItem: {
      type: Function,
      default: function (i) {
        return {
          label: i.label,
          value: i.value,
        }
      },
    },
    loadMoreFunc: {
      type: Function,
    },
    noMore: {
      type: Boolean,
    },
    excludeValues: {
      type: Array,
    },
    includeValues: {
      type: Array,
    },
    disabledFn: {
      type: Function,
    },
  },
  data() {
    console.log(window, this.dd)
    return {
      currentVal: this.value,
    }
  },
  computed: {
    list() {
      let trueList = this.options.map(this.formatItem).filter(i => !(this.excludeValues || []).includes(i.value))
      if (this.includeValues && this.includeValues.length) {
        trueList = trueList.filter(i => this.includeValues.includes(i.value))
      }
      if (typeof this.loadMoreFunc === 'function' && !this.noMore) {
        trueList.push({ disabled: true, label: '加载中...', value: '加载中', class: 'select-loading' })
      }
      if (typeof this.loadMoreFunc === 'function' && this.noMore) {
        trueList.push({ disabled: true, label: '没有更多了', value: '没有更多了', class: 'select-loading' })
      }
      return trueList
    },
  },
  watch: {
    currentVal(val) {
      this.$emit('input', val)
    },
    value(value) {
      this.currentVal = value
    },
  },
  mounted() {},
  methods: {
    itemDisabled(item) {
      if (this.disabledFn) {
        return this.disabledFn(item, this.value)
      }
      return item.disabled
    },
  },
  directives: {
    loadMore: {
      inserted(el, binding, vnode) {
        if (typeof binding.value !== 'function') {
          return
        }
        let loading = false
        const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
        SELECTWRAP_DOM.addEventListener('scroll', async function load() {
          const noMore = el.getAttribute('infinite-scroll-disabled')
          if (loading) return
          if (noMore === 'true') {
            SELECTWRAP_DOM.removeEventListener('scroll', load)
          }
          const CONDITION = this.scrollHeight - this.scrollTop <= this.clientHeight
          if (CONDITION) {
            loading = true
            if (binding.value) {
              await binding.value()
              loading = false
            }
          }
        })
      },
    },
  },
}
</script>
